import { useNotData, useData } from "./useNotShowPublicLogic";
import { isEmpty } from "lodash-es";
import type { ForceModalData } from "./useNotShowPublicLogic";
import router from "@/router";
import {uesShowForceModal} from "./useShow"
const popupTimeList = ['Recharge', 'Home', 'Withdrawal'] as const
export type APKTaskPopupTimeType = typeof popupTimeList[number]
export const apkTaskForceModal = async () => {
  const userStore = useUserStore();
  const systemStore = useSystemStore();   // 系统信息
  const notUseDataShowMap = useNotData()
  const { isAPKUser } = toRefs(userStore)
  const {  isIOS, } = toRefs(systemStore)
  // apk任务需要修改 ios 和 isAPKUser
  notUseDataShowMap.set('ios', () => isIOS.value)
  notUseDataShowMap.set('isAPKUser', () => isAPKUser.value)

  let isNotShow = [...notUseDataShowMap.values()].some(fn => fn())
  if (isNotShow) return false
  const isLogin = await useAppStore().checkUserHasLogin();
  if (!isLogin) return false
  const channelStore = useChannelStore(); // 渠道信息 
  const taskStore = useTaskStore()
  const route = router.currentRoute
  const ch = (route.value.query.ch || 0) as number
  const taskData = await taskStore.getInstallApkTaskDetail()
  if (isEmpty(taskData)) return false

  const { rewardMax, rewardMin, popupSwitch } = taskData

  const { popupInterval, range, apkUrl, popupType, domainRange } = taskData.otherConfig

  const expireDate = await channelStore.getCompulsoryInstallTime('taskAPK')
  const params: ForceModalData = {
    popupTime: 'HOME',
    installType: "APK",
    guideInstall: true,
    popupInterval: Number(popupInterval) || 0,
    expireDate,
    isNotOpen: popupSwitch !== 'ON'
  }
  const useDataShowMap = useData(params)
  const popupTimeInfo: ReadonlyMap<APKTaskPopupTimeType, boolean> = new Map([
    ['Recharge', !!userStore.user?.firstRechargeAmount],
    ['Withdrawal', userStore.user?.withdrawCount >= 1],
    ['Home', true],
  ]);

  const handleInRange = () => {
    let isInRange = domainRange.length ? domainRange.some((it: any) => it.name.includes(window.location.hostname)) : false
    if (!isInRange) {
      const channelIdList: number[] = range.reduce((acc: number[], cur: any) => {
        if (cur.channelIdList.length) {
          acc.push(...cur.channelIdList)
        }
        return acc;
      }, [])
      isInRange = channelIdList.includes(Number(ch))
    }
    return !isInRange
  }

  // apk任务需要修改 pwa 和 popupTime 增加 isInRange
  useDataShowMap.delete('pwa')
  useDataShowMap.set('popupTime', () => !(popupType as APKTaskPopupTimeType[]).some(it => popupTimeInfo.get(it)))
  useDataShowMap.set('isInRange', handleInRange)

  isNotShow = [...useDataShowMap.values()].some(fn => fn())
  if (isNotShow) return false

  const getPopupTime = () => {
    let popupTime = ""
    for (const [key, value] of popupTimeInfo) {
      if (value && popupType.includes(key)) {
        popupTime = key
        break
      }
    }
    return popupTime
  }


  channelStore.promotionInfo = {
    ...(channelStore?.promotionInfo || {}),
    installType: "APK",
    installUrl: apkUrl,
    popupInterval: `${popupInterval}`,
    popupTime: getPopupTime(),
    showGiftAmount: [`${rewardMin}`, `${rewardMax}`],
  }

  return uesShowForceModal('taskAPK')
}
